<template>
  <div class="pa-2">
    <div class="" v-if="examen">
      <div class="ma-2 d-flex justify-space-between align-items-center">
        <div class="d-flex">
          <div class="mx-4">
            <h3 class="title-1">Postulante</h3>
            <p class="subtitle-1">
              {{
                examen.postulant.firstName +
                  " " +
                  examen.postulant.lastName +
                  " " +
                  examen.postulant.motherLastName
              }}
            </p>
          </div>

          <div class="mx-4">
            <h3 class="title-1">
              UPG:
            </h3>
            <p class="subtitle-1">{{ examen.postulant.upgCode }}</p>
          </div>
           <div class="mx-4">
            <h3 class="title-1">
              Programa:
            </h3>
            <p class="subtitle-1">{{ examen.postulant.programCode }}</p>
          </div>
        </div>

        <div class="mx-2 card score">
          <h3 class="title-1">
            Puntaje:
          </h3>
          <h3 class="title-1">{{ examen.score }}</h3>
        </div>
      </div>

      <section
        class="question card ma-2"
        v-for="question in examen.questions"
        :key="question.content.id"
      >
        <p class="text-center">Pregunta {{ question.content.number }}:</p>
        <p class="" v-html="question.content.question.content"></p>
        <hr />
        <div class="question__alternatives">
          <div
            class="question__alternative"
            v-for="(alternative, idx) in question.content.alternatives"
            :key="alternative.id"
            v-bind:class="{
              selected: question.content.postulantAnswerId == alternative.id,
              correctMarked:
                question.content.postulantAnswerId == alternative.id &&
                alternative.id == question.answerId,
              incorrect:
                question.content.postulantAnswerId == alternative.id &&
                alternative.id !== question.answerId,
              correct: alternative.id == question.answerId,
            }"
          >
            <span
              ><span> {{ toOption(idx) }}.- </span
              >{{ alternative.content }}</span
            >
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { postulantExam } from "@/services/postulantExam";

export default {
  data: () => ({
    examen: null,
    error: null,
    loading: true,
  }),
  async created() {
    this.loading = false;
  },
  mounted() {
    const postulanteId = this.$route.query.postulantExam;
    postulantExam
      .get(postulanteId)
      .then((r) => {
        this.examen = r.data;
      })
      .catch(() => {
        this.$swal("Oops...", "Examen no encontrado", "error");
        this.$router.go(-1)
      });
  },
  methods: {
    toOption(answer) {
      return ["a", "b", "c", "d"][answer] || "-";
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/question.scss";
.selected {
  font-weight: bold;
}
.correct {
  font-weight: bold;
}
.correctMarked {
  color: white;
  background: green;
}
.incorrect {
  color: white;
  background: red;
}
.score {
  border: 1px solid #aca6a6;
  border-radius: 5%;
  text-align: center;
}
</style>
